import { useEffect, useState } from "react";
import { api, CATEGORY_LABELS, fmtDate, fmtMoney } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { useFiles } from "@/context/FilesContext";
import { DecisionBox, StatusBadge, Timeline } from "@/components/files/Approvals";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AccountingExport } from "@/components/files/AccountingExport";

export default function Validations() {
  const { me } = useMe();
  const { openFile, bump, refreshKey } = useFiles();
  const [scope, setScope] = useState("todo");
  const [items, setItems] = useState(null);
  const load = () => api.get("/approvals", { params: { scope } }).then((r) => setItems(r.data));
  useEffect(() => { setItems(null); load(); }, [scope, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-5xl mx-auto fade-up" data-testid="validations-page">
      <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">Circuit factures et devis</p>
      <div className="flex items-start justify-between gap-4 flex-wrap mt-1 mb-2">
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Validations</h1>
        {["admin", "responsable"].includes(me.role) && <AccountingExport />}
      </div>
      <p className="text-sm text-slate-500 mb-6">Chaque document passe par un responsable puis par la direction. Ouvrez un document et allez dans l'onglet « Validation » pour le soumettre.</p>
      <Tabs value={scope} onValueChange={setScope}>
        <TabsList className="mb-5">
          <TabsTrigger value="todo" data-testid="validations-tab-todo">À traiter</TabsTrigger>
          <TabsTrigger value="mine" data-testid="validations-tab-mine">Mes demandes</TabsTrigger>
          {me.role === "admin" && <TabsTrigger value="all" data-testid="validations-tab-all">Historique complet</TabsTrigger>}
        </TabsList>
      </Tabs>
      {items && items.length === 0 && <div className="border border-dashed rounded-xl py-16 text-center text-sm text-slate-500" data-testid="validations-empty">
        {scope === "todo" ? "Rien à valider pour le moment." : "Aucune demande."}</div>}
      <div className="space-y-4">
        {items?.map((a) => (
          <div key={a.id} className="bg-white border rounded-xl p-5 grid md:grid-cols-[1fr_280px] gap-5" data-testid={`approval-card-${a.id}`}>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <button onClick={() => openFile(a.file_id)} className="font-semibold text-sm hover:text-[#1E3A8A] truncate" data-testid={`approval-open-file-${a.id}`}>{a.file_name}</button>
                <StatusBadge a={a} />
              </div>
              <div className="text-xs text-slate-500 mt-1">
                {CATEGORY_LABELS[a.doc_type] || "Document"}{a.supplier && ` · ${a.supplier}`}{a.amount_ttc != null && ` · ${fmtMoney(a.amount_ttc, a.currency)}`} · soumis le {fmtDate(a.created_at, true)}
              </div>
              <div className="mt-4"><Timeline a={a} /></div>
            </div>
            <div>
              {a.can_act ? <DecisionBox a={a} onDone={() => { load(); bump(); }} /> :
                <Button variant="outline" className="w-full" onClick={() => openFile(a.file_id)}>Voir le document</Button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
